export default __webpack_public_path__ + "static/media/segment.bcb636f3.svg";